module.exports = __webpack_public_path__ + "media/images/icon-prescreening-2177013624e434cd0c11d84710c82e88.png";